var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatSpin-wrapper",style:({height:_vm.height + 'px',width:_vm.width,background:_vm.bgColor})},[_c('a-spin',{staticClass:"topchatSpin",attrs:{"size":_vm.size,"tip":_vm.tip}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }